import { Component, ElementRef, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { of } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { ParentUsers } from '../Models/ActiveClasses';
import { Agencies_BranchesProperties } from '../Models/AgencyMasterProperties';
import { loginUserList, managerlistbyuserid } from '../Models/BookingListProperties';
import { OfflineBookingAllList, OfflineBookingListOnlineDetailsOrOffline, OfflineRequestType } from '../Models/OfflineBookingProperties';
import { AgencyService } from '../Services/Agency.service';
import { BookingListService } from '../Services/bookingList.service';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { OfflineNewVersionService } from '../Services/offline-newVersion.service';
import { Router } from '@angular/router';
import { OfflineNewVersionBookingStatus, OfflineNewVersionProperties, OfflineRequestTypeEnum, OfflineStatusNewVersion } from '../offline-new/offlineNewProperties';
import { OfflineToOnlineProperties, TicketPnrRights } from '../Models/TicketIssuanceProperties';
import { TicketIssuanceService } from '../Services/ticketIssuance.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OfflineRequestService } from '../Services/offline-request.service';
@Component({
  selector: 'app-offline-back-office-report',
  templateUrl: './offline-back-office-report.component.html',
  styleUrls: ['./offline-back-office-report.component.css']
})
/** ManagerProficiencyReport component*/
export class OfflineBackOfficeReportComponent {
  userId: number;
  /** ManagerProficiencyReport ctor */
  constructor(private service: OfflineNewVersionService, private NewSuccess: NgbModal, private ticketIssuanceService: TicketIssuanceService, private router: Router, private bookingListService: BookingListService, private agencyservice: AgencyService, private messageService: MessageService, private offlinenewservice: OfflineNewVersionService
    ) {
    this.onClickEditRequest = this.onClickEditRequest.bind(this);
  }
  @ViewChild("confirmationModal", null) confirmationModal: ElementRef;
  tktPnrRight = new TicketPnrRights();
  getOfflineRequestTypeList: OfflineRequestType[] = [];
  datasoruceBooking: OfflineNewVersionProperties[] = [];
  userlist: ParentUsers[] = [];
  offlineStatusNew: OfflineStatusNewVersion[] = [];
  agencyCodeList$: Observable<Agencies_BranchesProperties[]>;
  agencyCodefinalList$: Observable<Agencies_BranchesProperties[]>;
  offlineProperties = new OfflineSearchReportProperties();
  agencyList: Agencies_BranchesProperties[] = [];
  newagencyList: Agencies_BranchesProperties[] = [];
  managerList: managerlistbyuserid[] = [];
  agencyhead: boolean = false;
  ngOnInit() {
    this.getlistofUsers((localStorage.getItem("AgencyId")));
    this.LoadAgencyList();
    this.getrequestType();
    this.getOfflineStatus();
    this.loadrights();
    this.offlineOrOnlineRequestList.agencyId = localStorage.getItem("AgencyId");
    this.offlineOrOnlineRequestList.userId = Number(localStorage.getItem("UserId"));
  }
  loadrights() {
    ////////////////////////////////////////
    this.ticketIssuanceService
      .CheckTktPnrRightsAgainstAgencyAndUserId(
        localStorage.getItem("AgencyId"),
        localStorage.getItem("UserId")
      )
      .subscribe((data2) => {
        this.tktPnrRight = data2;
        // console.log("LoadRights: tktPnrRight", this.tktPnrRight);
        //console.log("LoadRights: requestList", this.requestList);
      });
  }
  LoadAgencyList() {
    try {
      let loginAgency = "";


      if ((localStorage.getItem("AgencyId") != undefined) && (localStorage.getItem("") != "") && (localStorage.getItem("AgencyId") != null)) {
        loginAgency = localStorage.getItem("AgencyId")
        if ((localStorage.getItem("UserId") != undefined) && (localStorage.getItem("UserId") != "") && (localStorage.getItem("UserId") != null))
          this.userId = Number(localStorage.getItem("UserId"));
        if (this.userId != 0) {
          this.bookingListService.GetAllAgencies(loginAgency, this.userId).subscribe((data) => {
            this.agencyList = data;
            this.agencyCodeList$ = of(data);
          });
        }
      }
    }
    catch (e) {
    }
  }


  getrequestType() {
    this.bookingListService.GetOfflineRequestTypeList().subscribe((data) => {
      //////Console.log(data);
      if (data.length > 0) {
        this.getOfflineRequestTypeList = data;
        //////Console.log(this.userlist);
      }
    })
  }
  onExporting(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');
    exportDataGrid({
      component: e.component,
      worksheet: worksheet,
      autoFilterEnabled: true,
      customizeCell: function (options) {
        const excelCell = options;
        // exce = { name: 'Arial', size: 12 };
        // excelCell.alignment = { horizontal: 'left' };
      }
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'B2BBackOfficeReport.xlsx');
        });
    });
    e.cancel = true;
  }
  formatDate(date: Date): string {
    const year = date.getFullYear();
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // months are 0-based
    return `${year}-${month}-${day}`;
  }
  onSubmit() {
    if ((this.offlineProperties.startDate != undefined && this.offlineProperties.endDate == undefined)) {
      this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Please select the Booking To date when Booking From date is selected.' });
      
      return;
    }
    if ((this.offlineProperties.startDate == undefined && this.offlineProperties.endDate != undefined)) {
      this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Please select the Booking From date when Booking To date is selected.' });

      return;
    }
    if ((this.offlineProperties.startDate != undefined && this.offlineProperties.endDate != undefined)) {
      const startdate = new Date(this.offlineProperties.startDate);
      const enddate = new Date(this.offlineProperties.endDate);
      if (startdate > enddate) {
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Please select the Booking From date is less than from Booking To date.' });

        return;
      }
      
    }
    if (this.offlineProperties.bookingId == undefined || this.offlineProperties.bookingId == null) {
      this.offlineProperties.bookingId = 0;
    }
    if (this.offlineProperties.creationUser == undefined || this.offlineProperties.creationUser == null) {
      this.offlineProperties.creationUser = 0;
    }
    if (this.offlineProperties.offlineBookingRequestId == undefined || this.offlineProperties.offlineBookingRequestId == null) {
      this.offlineProperties.offlineBookingRequestId = 0;
    }
    if (this.offlineProperties.status == undefined || this.offlineProperties.status == null) {
      this.offlineProperties.status = 0;
    }
    if (this.offlineProperties.startDate != undefined || this.offlineProperties.agencyBranchId != undefined || this.offlineProperties.bookingId != 0 || this.offlineProperties.endDate != undefined
      || this.offlineProperties.creationUser != 0 || this.offlineProperties.offlineBookingRequestId != 0 || this.offlineProperties.status !=0 ) {
      if (this.offlineProperties.startDate != undefined) {
        const deptdate = new Date(this.offlineProperties.startDate);
        this.offlineProperties.startDate = this.formatDate(deptdate);
      }
      if (this.offlineProperties.endDate != undefined) {
        const deptdate = new Date(this.offlineProperties.endDate);
        this.offlineProperties.endDate = this.formatDate(deptdate);
      }
      this.datasoruceBooking = [];
      this.offlinenewservice.OfflineBackOfficeReportGetbyCriteria(this.offlineProperties).subscribe((data) => {
        //////Console.log(data);
        if (data.length > 0) {
          this.datasoruceBooking = data;
          this.loadCharts();
          //////Console.log(this.userlist);
        }
        else {
          this.messageService.add({ severity: 'error', summary: 'Empty', detail: 'Not Found Any Data' });
        }
      })
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Please select criteria must be one field' });
      return;
    }
  
   
  }
  getOfflineStatus() {
    this.offlinenewservice.GetOfflineStatus().subscribe((data) => {
      if (data != null && data.length > 0) {
        this.offlineStatusNew = data;
      }
    });
  }
  getlistofUsers(str) {
   
    if (str == null) {
      return;
    }
    /*  if (str.includes("B")) {*/
    this.userlist = [];

    this.agencyservice.GetUsersForManagers(str).subscribe((data) => {
      //////Console.log(data);
      if (data.length > 0) {
        this.userlist = data;
        //////Console.log(this.userlist);
      }
    })
    /*    }*/
  }
  dataStatus: any;
  dataRequestTypeOnline: any;
  dataRequestTypeOffline: any;
  options: any;
  loadCharts() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    let booked = this.datasoruceBooking.filter(ty => ty.currentBookingStatus == OfflineNewVersionBookingStatus.Booked).length;
    let ticketed = this.datasoruceBooking.filter(ty => ty.currentBookingStatus == OfflineNewVersionBookingStatus.Ticketed).length;
    let inProgress = this.datasoruceBooking.filter(ty => ty.currentBookingStatus == OfflineNewVersionBookingStatus.InProgress).length;
    let invoiced = this.datasoruceBooking.filter(ty => ty.currentBookingStatus == OfflineNewVersionBookingStatus.Invoiced).length;
    let removedFromList = this.datasoruceBooking.filter(ty => ty.currentBookingStatus == OfflineNewVersionBookingStatus.RemovedFromList).length;
    let requested = this.datasoruceBooking.filter(ty => ty.currentBookingStatus == OfflineNewVersionBookingStatus.Requested).length;
    let ticketonline = this.datasoruceBooking.filter(ty => ty.offlineRequestType === OfflineRequestTypeEnum.OfflineBookingGroupRequest).length;
    //let voidonline = this.datasoruceBooking.filter(ty => ty.offlineRequestType === 8).length;
    //let refundonline = this.datasoruceBooking.filter(ty => ty.offlineRequestType === 14).length;
    //let importonline = this.datasoruceBooking.filter(ty => ty.offlineRequestType === 15).length;

    //let ticketoffline = this.datasoruceBooking.filter(ty => ty.offlineRequestType === 3).length;
    //let voidoffline = this.datasoruceBooking.filter(ty => ty.offlineRequestType === 4).length;
    //let refundoffline = this.datasoruceBooking.filter(ty => ty.offlineRequestType === 5).length;
    
    this.dataStatus = {
      labels: ['Requested', 'In Progress', 'Booked','Ticketed','Invoiced','Removed From List'],
      datasets: [
        {
          data: [requested, inProgress,booked, ticketed,  invoiced, removedFromList],
          backgroundColor: [documentStyle.getPropertyValue('--blue-500'), documentStyle.getPropertyValue('--red-500'), documentStyle.getPropertyValue('--green-500'), documentStyle.getPropertyValue('--yellow-500'), documentStyle.getPropertyValue('--orange-500'), documentStyle.getPropertyValue('--purple-500')],
          hoverBackgroundColor: [documentStyle.getPropertyValue('--blue-400'), documentStyle.getPropertyValue('--red-400'), documentStyle.getPropertyValue('--green-400'), documentStyle.getPropertyValue('--yellow-400'), documentStyle.getPropertyValue('--orange-400'), documentStyle.getPropertyValue('--purple-400')],
        }
      ]
    };
    //this.dataRequestTypeOnline = {
    //  labels: ['Offline Booking Request'],
    //  datasets: [
    //    {
    //      data: [ticketonline],
    //      backgroundColor: [documentStyle.getPropertyValue('--blue-500')],
    //      hoverBackgroundColor: [documentStyle.getPropertyValue('--blue-400')]
    //    }
    //  ]
    //};
    this.dataRequestTypeOffline = {
      labels: ['Offline Booking Request'],
      datasets: [
        {
          data: [ticketonline],
          backgroundColor: [documentStyle.getPropertyValue('--blue-500')],
          hoverBackgroundColor: [documentStyle.getPropertyValue('--blue-400')]
        }
      ]
    };

    this.options = {
      cutout: '60%',
      plugins: {
        legend: {
          labels: {
            color: textColor
          }
        }
      }
    };
  }
  OpenModel(confirmationModal) {
    this.NewSuccess.open(confirmationModal, {
      centered: true,
      backdrop: "static",
      keyboard: false,
      size: "md",
    });
  }
  requestData: any;
  offlinetoOnline = new OfflineToOnlineProperties();
  offlineOrOnlineRequestList = new OfflineBookingListOnlineDetailsOrOffline();

  onClickEditRequest(e) {
    if (e.row.data.offlineRequestTypeName == "Online Ticket Request") {
      this.OpenModel(this.confirmationModal);
      this.requestData = e.row.data;
    }
   
    else if (e.row.data.offlineRequestTypeName == "Online Import PNR Ticket Request") {
      localStorage.setItem("importPNRID", e.row.data.onlineBookingId);
      localStorage.setItem("fromroutePageNoright", "OfflinePagemanger");
      localStorage.setItem('isOfflineParked', "True");
      this.OpenModel(this.confirmationModal);
      this.requestData = e.row.data;
      localStorage.setItem('ImportPnrRequestData', JSON.stringify(this.requestData));
      // this.router.navigateByUrl('/importPNR');
    }
    else if (e.row.data.offlineRequestTypeName == "Online Void Request") {
      if (this.tktPnrRight.voidTicket) {
        localStorage.setItem("bookingID", e.row.data.onlineBookingId);
        this.offlinetoOnline.RequestTypeIdOffline =
          e.row.data.offlineRequestTypeName;
        this.offlinetoOnline.AgencyTicketReqFromOffline = e.row.data.requestingAgency;
        this.offlinetoOnline.VoidReqFromOffline = true;
        localStorage.setItem("OffilineRequest", "True");
        localStorage.setItem("fromroutePageNoright", "OfflinePagemanger");
        this.offlinetoOnline.OfflineId = Number(e.row.data.offlineId);
        localStorage.setItem(
          "OfflineToOnline",
          JSON.stringify(this.offlinetoOnline)
        );
        this.router.navigate(["/ticket-issuance"]);
      } else {
        localStorage.setItem("bookingID", e.row.data.onlineBookingId);
        this.offlinetoOnline.RequestTypeIdOffline =
          e.row.data.offlineRequestTypeName;
        this.offlinetoOnline.AgencyTicketReqFromOffline = e.row.data.requestingAgency;
        this.offlinetoOnline.VoidReqFromOffline = true;
        localStorage.setItem("OffilineRequest", "False");
        localStorage.setItem("fromroutePageNoright", "OfflinePagemanger");
        this.offlinetoOnline.OfflineId = Number(e.row.data.offlineId);
        localStorage.setItem(
          "OfflineToOnline",
          JSON.stringify(this.offlinetoOnline)
        );
        this.router.navigate(["/ticket-issuance"]);
      }
    }
    else if (e.row.data.offlineRequestTypeName == "Online PNR Cancel Request") {
      if (this.tktPnrRight.cancelPnr) {
        localStorage.setItem("bookingID", e.row.data.onlineBookingId);
        this.offlinetoOnline.RequestTypeIdOffline =
          e.row.data.offlineRequestTypeName;
        this.offlinetoOnline.AgencyTicketReqFromOffline = e.row.data.requestingAgency;
        this.offlinetoOnline.PNRReqFromOffline = true;
        localStorage.setItem("OffilineRequest", "True");
        localStorage.setItem("fromroutePageNoright", "OfflinePagemanger");
        this.offlinetoOnline.OfflineId = Number(e.row.data.offlineId);
        localStorage.setItem(
          "OfflineToOnline",
          JSON.stringify(this.offlinetoOnline)
        );
        this.router.navigate(["/ticket-issuance"]);
      } else {
        localStorage.setItem("bookingID", e.row.data.onlineBookingId);
        this.offlinetoOnline.RequestTypeIdOffline =
          e.row.data.offlineRequestTypeName;
        this.offlinetoOnline.AgencyTicketReqFromOffline = e.row.data.requestingAgency;
        this.offlinetoOnline.PNRReqFromOffline = true;
        localStorage.setItem("OffilineRequest", "False");
        localStorage.setItem("fromroutePageNoright", "OfflinePagemanger");
        this.offlinetoOnline.OfflineId = Number(e.row.data.offlineId);
        localStorage.setItem(
          "OfflineToOnline",
          JSON.stringify(this.offlinetoOnline)
        );
        this.router.navigate(["/ticket-issuance"]);
      }
    }
    else if (e.row.data.offlineRequestTypeName == "Online Refund Request") {
      if (this.tktPnrRight.refund) {
        localStorage.setItem("bookingID", e.row.data.onlineBookingId);
        this.offlinetoOnline.RequestTypeIdOffline =
          e.row.data.offlineRequestTypeName;
        this.offlinetoOnline.AgencyTicketReqFromOffline = e.row.data.requestingAgency;
        this.offlinetoOnline.RefundReqFromOffline = true;
        localStorage.setItem("OffilineRequest", "True");
        localStorage.setItem("fromroutePageNoright", "OfflinePagemanger");
        this.offlinetoOnline.OfflineId = Number(e.row.data.offlineId);
        localStorage.setItem(
          "OfflineToOnline",
          JSON.stringify(this.offlinetoOnline)
        );
        this.router.navigate(["/ticket-issuance"]);
      } else {
        localStorage.setItem("bookingID", e.row.data.onlineBookingId);
        this.offlinetoOnline.RequestTypeIdOffline =
          e.row.data.offlineRequestTypeName;
        this.offlinetoOnline.AgencyTicketReqFromOffline = e.row.data.requestingAgency;
        this.offlinetoOnline.RefundReqFromOffline = true;
        localStorage.setItem("OffilineRequest", "False");
        localStorage.setItem("fromroutePageNoright", "OfflinePagemanger");
        this.offlinetoOnline.OfflineId = Number(e.row.data.offlineId);
        localStorage.setItem(
          "OfflineToOnline",
          JSON.stringify(this.offlinetoOnline)
        );
        this.router.navigate(["/ticket-issuance"]);
      }
    }

    //20-jan-24
    else if (e.row.data.offlineRequestTypeName.includes("Offline")) {

      if (e.row.data.offlineRequestTypeName == "Offline Booking/Group Request") {
        this.service
          .GetOfflineBookingById(e.row.data.offlineId).subscribe((data) => {
            if (data != null && data != undefined && data.offlineId > 0) {
              if (data.inProgressTag) {
                this.loadBaseData();
                this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'In Progress Select Other One' });


              }
              else {
                localStorage.setItem('RequestActionOffline', 'Agent');
                localStorage.setItem('RequestTypeOffline', 'Update');
                localStorage.setItem("offlineBookingId", e.row.data.offlineId);
                localStorage.setItem("requestingAgency", e.row.data.requestingAgency);
                localStorage.setItem("offlineBookingCurnStatus", e.row.data.currentBookingStatus);
                localStorage.setItem('fromOfflineRequestRoute', 'managerOfflineRequestList');
                this.router.navigateByUrl("/offlineBooking");
              }
            }

          });



      }
      else if (e.row.data.offlineRequestTypeName == "Offline Ticket Request") {
        this.service
          .GetOfflineBookingById(e.row.data.offlineId).subscribe((data) => {

            if (data != null && data != undefined && data.offlineId > 0) {
              if (data.inProgressTag) {
                this.loadBaseData();
                this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'In Progress Select Other One' });


              }
              else {
                localStorage.setItem('RequestActionOffline', 'Agent');
                localStorage.setItem('RequestTypeOffline', 'Update');
                localStorage.setItem("offlineBookingId", e.row.data.offlineId);
                localStorage.setItem("requestingAgency", e.row.data.requestingAgency);
                localStorage.setItem('RequestTypeIdFromOffline', OfflineRequestTypeEnum.OfflineTicketRequest.toString());
                localStorage.setItem("offlineBookingCurnStatus", e.row.data.currentBookingStatus);
                localStorage.setItem('fromOfflineRequestRoute', 'managerOfflineRequestList');
                this.router.navigateByUrl("/offlineTicket");
              }
            }

          });



      }
      else if (e.row.data.offlineRequestTypeName == "Offline Void Request") {
        this.service
          .GetOfflineBookingById(e.row.data.offlineId).subscribe((data) => {
            if (data != null && data != undefined && data.offlineId > 0) {
              if (data.inProgressTag) {
                this.loadBaseData();
                this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'In Progress Select Other One' });


              }
              else {

                localStorage.setItem('RequestActionOffline', 'Agent');
                localStorage.setItem('RequestTypeOffline', 'Update');
                localStorage.setItem('RequestTypeIdFromOffline', OfflineRequestTypeEnum.OfflineVoidRequest.toString());
                localStorage.setItem("offlineBookingId", e.row.data.offlineId);
                localStorage.setItem("requestingAgency", e.row.data.requestingAgency);
                localStorage.setItem("offlineBookingCurnStatus", e.row.data.currentBookingStatus);
                localStorage.setItem('fromOfflineRequestRoute', 'managerOfflineRequestList');
                this.router.navigateByUrl("/offlineVoid");
              }
            }

          });



      }
      else if (e.row.data.offlineRequestTypeName == "Offline Refund Request") {
        this.service
          .GetOfflineBookingById(e.row.data.offlineId).subscribe((data) => {
            if (data != null && data != undefined && data.offlineId > 0) {
              if (data.inProgressTag) {
                this.loadBaseData();
                this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'In Progress Select Other One' });


              }
              else {

                localStorage.setItem('RequestActionOffline', 'Agent');
                localStorage.setItem('RequestTypeOffline', 'Update');
                localStorage.setItem('RequestTypeIdFromOffline', OfflineRequestTypeEnum.OfflineRefundRequest.toString());
                localStorage.setItem("offlineBookingId", e.row.data.offlineId);
                localStorage.setItem("requestingAgency", e.row.data.requestingAgency);
                localStorage.setItem("offlineBookingCurnStatus", e.row.data.currentBookingStatus);
                localStorage.setItem('fromOfflineRequestRoute', 'managerOfflineRequestList');
                this.router.navigateByUrl("/offlineRefund");
              }
            }

          });



      }
      else if (e.row.data.offlineRequestTypeName == "Offline Reissue Request") {
        this.service
          .GetOfflineBookingById(e.row.data.offlineId).subscribe((data) => {
            if (data != null && data != undefined && data.offlineId > 0) {
              if (data.inProgressTag) {
                this.loadBaseData();
                this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'In Progress Select Other One' });


              }
              else {

                localStorage.setItem('RequestActionOffline', 'Agent');
                localStorage.setItem('RequestTypeOffline', 'Update');
                localStorage.setItem('RequestTypeIdFromOffline', OfflineRequestTypeEnum.OfflineReissueRequest.toString());
                localStorage.setItem("offlineBookingId", e.row.data.offlineId);
                localStorage.setItem("requestingAgency", e.row.data.requestingAgency);
                localStorage.setItem("offlineBookingCurnStatus", e.row.data.currentBookingStatus);
                localStorage.setItem('fromOfflineRequestRoute', 'managerOfflineRequestList');
                this.router.navigateByUrl("/offlineReissue");
              }
            }

          });



      }

    }

  }
  loadBaseData() {
    this.datasoruceBooking = [];
    this.offlinenewservice.OfflineBackOfficeReportGetbyCriteria(this.offlineProperties).subscribe((data) => {
      //////Console.log(data);
      if (data.length > 0) {
        this.datasoruceBooking = data;
        this.loadCharts();
        //////Console.log(this.userlist);
      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Empty', detail: 'Not Found Any Data' });
      }
    })
  }
}

export class OfflineSearchReportProperties {
  startDate: string ;
  endDate: string ;
  agencyBranchId: string ;
  creationUser: number=0;
  offlineBookingRequestId: number=0;
  bookingId: number = 0;
  status: number = 0;
}
